import axios from "@/utils/axios";

// 'https://nodejs.dbchain.ai'
// 'http://82.157.50.32:8090'
// http://localhost:8090
// 审核机器新增

const nodeHost = 'http://localhost:8099'
// const testHost = 'http://8.219.75.114:8094'
const testHost = 'https://www.deeplink.cloud'



/**
 * @description 获取邮箱验证码
 * @param {object} params { email }
 */
export const getVircode = data => {
  return axios({
    method: "post",
    url: testHost + "/api/pre/getvircode",
    data: data
  });
};

/**
 * @description 提交KYC认证信息
 * @param {object} params 
 */
 export const uploadKYCInfo = data => {
  return axios({
    method: "post",
    url: testHost + "/api/pre/uploadKYCInfo",
    data: data
  });
};


/**
 *  麻瓜支付
 * 1. 获取 Api_Key (密钥)
 *    api_key: 2834ab80-97d6-11ee-a2da-bbe29beef505
 * 
 * 
 */

// 创建订单
export const getMugglyOrders = (data) => {
  return axios({
    headers: {
      'token': '2834ab80-97d6-11ee-a2da-bbe29beef505',
      'content-type': 'application/json' 
    },
    method: "post",
    url: 'https://api.mugglepay.com/v1/orders',
    data: data
  });
};


// 存储购买dbc和dlc的订单
export const buyCurrency = (data) => {
  return axios({
    method: "post",
    url: testHost + '/api/pre/paymentorder',
    data: data
  })
}

// 获取国家列表
export const getCountlist = () => {
  return axios({
    method: "get",
    url: testHost + '/api/pre/getCountryList' 
  });
};

// 获取用户数量
export const getUserNumber = () => {
  return axios({
    method: "get",
    url: testHost + '/api/pre/getUserNumber' 
  });
};

// 获取用户邀请码
export const getInviteCode = (data) => {
  return axios({
    method: "post",
    url: testHost + '/api/pre/getInviteCode',
    data: data
  })
}


// 获取用户KYC信息 
export const getKycInfo = (data) => {
  return axios({
    method: "post",
    url: testHost + '/api/pre/getKycInfo',
    data: data
  })
}
